import axios from 'axios';
import { apiBaseUrl } from '../config';

const opts = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
});

/**
 * Trigger a simple manual task ('fetch_ohlcv_eod' | 'fetch_ohlcv_1m' | 'fetch_ohlcv_5m' | 'fetch_ohlcv_15m').
 * Recorded as a ManualJob and visible in Job History.
 */
export const triggerSimpleTask = (token, task) =>
  axios.post(`${apiBaseUrl}/admin/marketdata/triggertask`, { task }, opts(token));

/**
 * Start a historical OHLCV backfill job.
 * payload: { scope?, symbols?, interval?, start_date, end_date }
 */
export const triggerBackfillJob = (token, payload) =>
  axios.post(`${apiBaseUrl}/admin/marketdata/backfill`, payload, opts(token));

/**
 * List manual jobs (all types, newest first) — drives the Manual Jobs polling table.
 * `from`/`to` are YYYY-MM-DD and filter on the job trigger date (created_at).
 */
export const listManualJobs = (token, { page = 0, limit = 100, status, job_type, from, to } = {}) =>
  axios.get(`${apiBaseUrl}/admin/marketdata/jobs`, {
    ...opts(token),
    params: {
      page, limit,
      ...(status ? { status } : {}),
      ...(job_type ? { job_type } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
    },
  });

/**
 * Fetch a single manual job with full per-symbol results / result summary.
 */
export const getManualJob = (token, id) =>
  axios.get(`${apiBaseUrl}/admin/marketdata/jobs/${id}`, opts(token));

// ── Fyers provider administration ───────────────────────────────────────────

/** Token expiry, refresh-token days remaining, rate-limit usage, symbol master. */
export const getFyersStatus = (token) =>
  axios.get(`${apiBaseUrl}/admin/marketdata/fyers/status`, opts(token));

/** Issue a single-use CSRF state and the Fyers login URL to open in a browser. */
export const getFyersAuthUrl = (token) =>
  axios.get(`${apiBaseUrl}/admin/marketdata/fyers/authurl`, opts(token));

/** Force a token refresh now, instead of waiting for the next window. */
export const refreshFyersToken = (token) =>
  axios.post(`${apiBaseUrl}/admin/marketdata/fyers/refresh`, {}, opts(token));

/** Clear stored credentials; the read path falls back to stored candles. */
export const disconnectFyers = (token) =>
  axios.post(`${apiBaseUrl}/admin/marketdata/fyers/disconnect`, {}, opts(token));

/** Active source plus dispatch/cache/HTTP/realtime counters. */
export const getMarketDataSource = (token) =>
  axios.get(`${apiBaseUrl}/admin/marketdata/source`, opts(token));

/** Switch the active source ('yahoo' | 'fyers'). Effective without a deploy. */
export const setMarketDataSource = (token, source) =>
  axios.put(`${apiBaseUrl}/admin/marketdata/source`, { source }, opts(token));
